import { atom } from "recoil";

const openMovieAtom = atom({
  key: "openMovieState",
  default: false,
});

export default openMovieAtom;
